import { render, staticRenderFns } from "./ExpertCourts.vue?vue&type=template&id=326b0aa3&lang=pug&"
import script from "./ExpertCourts.vue?vue&type=script&lang=js&"
export * from "./ExpertCourts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports